<template>
    <div class="lg:container pb-20 text-center" id="list" v-touch:swipe.right="previous" v-touch:swipe.left="next">
        <div class="list-title">
            <div class="left" :class="{ inactive: ! previousAvailable }" @click="previous">‹</div>
            <div class="center">
                {{ monthName }}
            </div>
            <div class="right" :class="{ inactive: ! nextAvailable }" @click="next">›</div>
        </div>
        <div class="calendar">
            <div :class="'w-' + daysToSkip + '/7'"></div>
            <div class="day" 
              v-for="day in daysInMonth()" :key="day"
              :class="{'inactive': ! dayAvailable(day), 'today': today(day)}"
              @click="dayprediction(day)">
                {{ day }}
                <div class="actions" v-if="dayAvailable(day)">
                  <span v-for="action in actionsShow" :key="action">
                      <component 
                        v-if="actionHasQuality(day, action, -1)"
                        v-bind:is="actionIcon(action)" 
                        height="12" classes="bad" />
                      <component
                        v-if="actionHasQuality(day, action, 1)"
                        v-bind:is="actionIcon(action)" 
                        height="12" classes="good" />
                  </span>
                </div>
            </div>
        </div>
        <PageBlock classes="sm:w-1/2 sm:m-auto" v-if="! canUse('day-predictions-unlimited')">
            <UpgradePrompt />
        </PageBlock>
        <ActionSelector v-if="canUse('day-predictions-unlimited')" />
    </div>
</template>

<script>
import IconPersonal from '@/components/visual/icons/actions/IconPersonal'
import IconHaircut from '@/components/visual/icons/actions/IconHaircut'
import IconManicure from '@/components/visual/icons/actions/IconManicure'
import IconClothes from '@/components/visual/icons/actions/IconClothes'
import IconTravel from '@/components/visual/icons/actions/IconTravel'
import IconTakecredit from '@/components/visual/icons/actions/IconTakecredit'
import IconGivecredit from '@/components/visual/icons/actions/IconGivecredit'
import UpgradePrompt from '@/components/visual/UpgradePrompt'
import PageBlock from '@/components/visual/PageBlock'
import ActionSelector from '@/components/visual/ActionSelector'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'
import { mapState, mapGetters } from 'vuex'
export default {
  components: { IconHaircut, IconManicure, IconClothes, IconTravel, IconTakecredit, IconGivecredit, IconPersonal, UpgradePrompt, PageBlock, ActionSelector },
  mixins: [TimeFormatMixin],
  created() {
    this.setMonth()
  },
  computed: {
    actionsShow() {
        return this.actions.filter(action => this.actionsOn[action])
    },
    monthName() {
        return this.$t('month' + (this.current.month.getMonth() + 1))
    },
    previousAvailable() {
        if (! this.canUse('basic-auspiciousness-unlimited'))
          return false
        return this.previousMonth.getMonth() >= this.firstAvailableDate.getMonth()
    },
    nextAvailable() {
        return this.canUse('basic-auspiciousness-unlimited')
    },
    ...mapState('predictions', ['days', 'actions', 'actionsOn', 'current']),
    ...mapGetters('predictions', ['daysInMonth', 'daysToSkip', 'actionHasQuality', 'actionIcon', 'previousMonth', 'nextMonth', 'firstAvailableDate', 'dayAvailable']),
    ...mapGetters('auth', ['canUse']),
  },
  methods: {
    today(day) {
      var now = new Date
      if (this.current.month.getMonth() != now.getMonth()) 
        return false
      return (now.getDate() == day)
    },
    previous() {
      if (this.canUse('basic-auspiciousness-unlimited'))
        this.$store.dispatch('predictions/setPreviousMonth')
    },
    next() {
      if (this.canUse('basic-auspiciousness-unlimited'))
        this.$store.dispatch('predictions/setNextMonth')
    },
    dayprediction(day) {
      if (! this.dayAvailable(day))
        return 
      
      var date = new Date(this.current.month)
      date.setDate(day)
      this.$store.dispatch('predictions/setCurrentDay', date)
      this.$router.push({ name: 'dayprediction' })
    },
    setMonth() {
      this.$store.dispatch('predictions/setCurrentMonth', this.$route.params.month)
    }
  },
  watch: {
    '$route': 'setMonth',
  },
}
</script>

<i18n locale="ru" lang="yaml">
  noprediction: "Нет прогноза на этот день"
  month1: "Январь"
  month2: "Февраль"
  month3: "Март"
  month4: "Апрель"
  month5: "Май"
  month6: "Июнь"
  month7: "Июля"
  month8: "Август"
  month9: "Сентябрь"
  month10: "Октябрь"
  month11: "Ноябрь"
  month12: "Декабрь"
</i18n>

<i18n locale="en" lang="yaml">
  noprediction: "No prediction"
  month1: "January"
  month2: "February"
  month3: "March"
  month4: "April"
  month5: "May"
  month6: "June"
  month7: "July"
  month8: "August"
  month9: "September"
  month10: "October"
  month11: "November"
  month12: "December"
</i18n>
